{
  "wordmarkHome": "Sahab — home",
  "poweredBy": "Powered by",
  "menu": "Open menu",
  "skipToContent": "Skip to content",
  "breadcrumbs": "Breadcrumb",
  "back": "Back",
  "nav": {
    "label": "Main navigation",
    "home": "Home",
    "approvals": "My approvals",
    "sales": "Sales",
    "customers": "Customers",
    "customerGroups": "Customer groups",
    "administration": "Administration",
    "users": "Users",
    "roles": "Roles",
    "purchasing": "Purchasing",
    "suppliers": "Suppliers",
    "supplierGroups": "Supplier groups",
    "purchases": "Purchases",
    "supplierPayments": "Supplier payments",
    "supplierRefunds": "Supplier refunds",
    "supplierReturns": "Supplier returns",
    "payablesAging": "Payables aging",
    "pointOfSale": "Point of sale",
    "posTill": "Till",
    "posShifts": "Shifts",
    "posTills": "Tills",
    "loyalty": "Loyalty",
    "loyaltyOverview": "Overview",
    "loyaltyMembers": "Members",
    "loyaltyTransactions": "Transactions",
    "loyaltyProgram": "Programme",
    "accounting": "Accounting",
    "chartOfAccounts": "Chart of accounts",
    "journalEntries": "Journal entries",
    "trialBalance": "Trial balance",
    "fiscalYears": "Fiscal years",
    "accountMapping": "Account mapping",
    "cashBank": "Cash & bank",
    "cheques": "Cheques",
    "transfers": "Transfers",
    "expensesGroup": "Expenses",
    "expenses": "Expenses",
    "expenseCategories": "Categories",
    "recurringExpenses": "Recurring",
    "taxRates": "Tax rates",
    "quotations": "Quotations",
    "invoices": "Invoices",
    "creditNotes": "Credit notes",
    "receipts": "Receipts",
    "refunds": "Refunds",
    "receivablesAging": "Receivables aging",
    "auditLog": "Audit log",
    "privacyRequests": "Privacy requests",
    "settings": "Settings",
    "inventory": "Inventory",
    "products": "Products",
    "productCategories": "Product categories",
    "units": "Units",
    "attributes": "Attributes",
    "warehouses": "Warehouses",
    "stockLevels": "Stock levels",
    "stockMovements": "Stock movements",
    "serials": "Serial numbers",
    "stockAdjustments": "Stock adjustments",
    "stockTransfers": "Stock transfers",
    "profitAndLoss": "Profit and loss",
    "balanceSheet": "Balance sheet",
    "generalLedger": "General ledger",
    "vatReturn": "VAT return",
    "reports": "Reports",
    "cashFlow": "Cash flow",
    "booksHealth": "Books health",
    "salesByCustomer": "Sales by customer",
    "salesByProduct": "Sales by product",
    "salesByPeriod": "Sales by period",
    "salesByUser": "Sales and collections by user",
    "purchasesBySupplier": "Purchases by supplier",
    "purchasesByProduct": "Purchases by product",
    "stockValuation": "Stock valuation",
    "lowStock": "Low stock",
    "posSummary": "Till sales summary",
    "bankStatements": "Bank reconciliation",
    "work": "Work",
    "myWork": "My work",
    "tasks": "Tasks",
    "teams": "Teams",
    "taskReport": "Task delivery",
    "projectProfitability": "Project profitability",
    "projectBudgetVsActual": "Project budget against actual",
    "projectUnbilledWork": "Unbilled project work",
    "projectUtilisation": "Utilisation",
    "calendar": "Calendar",
    "service": "Service",
    "serviceOverview": "Service overview",
    "serviceJobs": "Service jobs",
    "serviceSchedule": "Schedule",
    "serviceMyVisits": "My visits",
    "serviceFollowUps": "Follow-up requests",
    "serviceCollections": "Collections",
    "serviceSites": "Sites & assets",
    "serviceContracts": "Maintenance contracts",
    "projects": "Projects",
    "projectsPortfolio": "Portfolio",
    "projectMaterialIssues": "Material issues",
    "projectCostEntries": "Cost entries",
    "projectReconciliation": "Contract reconciliation",
    "projectGuarantees": "Guarantees",
    "projectTime": "My time",
    "projectTimeApprovals": "Time approvals",
    "projectRates": "Hourly costs",
    "projectStatusReports": "Status reports",
    "serviceContractBilling": "Contract billing",
    "serviceContractInsights": "Contract insights",
    "hr": "Human resources",
    "hrDashboard": "HR overview",
    "hrEmployees": "Employees",
    "hrDocuments": "Document expiry",
    "hrPayComponents": "Pay components",
    "payroll": "Payroll",
    "payrollRuns": "Payroll runs",
    "payrollContributions": "Contribution rules",
    "payrollSettings": "Payroll settings",
    "salesBySalesperson": "Sales by salesperson",
    "commissions": "Commissions",
    "commissionRuns": "Commission runs",
    "commissionPlans": "Commission plans",
    "myCommission": "My commission"
  },
  "crumbs": {
    "projectClaim": "Progress claim",
    "projectReports": "Status reports",
    "projectReport": "Status report",
    "privacyRequest": "Request",
    "newCustomer": "New customer",
    "approvalRequest": "Request",
    "edit": "Edit",
    "changePassword": "Change password",
    "newUser": "New user",
    "newRole": "New role",
    "newSupplier": "New supplier",
    "newJournal": "New entry",
    "newExpense": "New expense",
    "newRecurringExpense": "New recurring expense",
    "newInvoice": "New invoice",
    "newDebitNote": "New debit note",
    "newQuotation": "New quotation",
    "newReceipt": "New receipt",
    "newCreditNote": "New credit note",
    "print": "Print",
    "estimate": "Estimate",
    "visitReport": "Visit report",
    "labels": "Labels",
    "assetLabels": "Asset labels",
    "newContract": "New contract",
    "newProduct": "New product",
    "newStockAdjustment": "New stock adjustment",
    "newPurchase": "New purchase",
    "newSupplierPayment": "New payment",
    "newSupplierReturn": "New return",
    "newRefund": "Refund credit",
    "newStockTransfer": "New stock transfer",
    "newSupplierRefund": "Record refund",
    "newBankStatement": "New statement",
    "workflows": "Approval workflows",
    "approvalRuns": "Approval requests",
    "approvalDelegations": "Delegations",
    "newEmployee": "Hire employee",
    "newCommissionPlan": "New plan"
  },
  "sidebar": {
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar"
  },
  "search": {
    "button": "Search…",
    "label": "Search and commands",
    "placeholder": "Type a screen or a command…",
    "empty": "No matches.",
    "serviceJobs": "Service jobs",
    "findAsset": "Find asset by tag",
    "goTo": "Go to",
    "thisPage": "This page",
    "actions": "Actions",
    "preferences": "Preferences",
    "account": "Account",
    "newCustomer": "New customer",
    "theme": "Theme: {{theme}}",
    "newUser": "New user",
    "newRole": "New role",
    "newSupplier": "New supplier",
    "newJournal": "New journal entry",
    "newExpense": "New expense",
    "newInvoice": "New invoice",
    "newQuotation": "New quotation",
    "newReceipt": "Record a receipt",
    "newCreditNote": "New credit note",
    "newProduct": "New product",
    "newStockAdjustment": "New stock adjustment",
    "newPurchase": "New purchase",
    "newSupplierPayment": "Pay a supplier",
    "newSupplierReturn": "New supplier return",
    "newRefund": "Refund a customer",
    "openTill": "Open the till",
    "newStockTransfer": "New stock transfer",
    "reports": "Reports",
    "newBankStatement": "New bank statement",
    "newTask": "New task",
    "newServiceJob": "New service job",
    "newContract": "New maintenance contract",
    "newProject": "New project",
    "newEmployee": "Hire employee"
  },
  "language": {
    "label": "Language",
    "switchToArabic": "Switch to Arabic",
    "switchToEnglish": "Switch to English",
    "arabic": "العربية",
    "english": "English"
  },
  "theme": {
    "label": "Theme",
    "light": "Light",
    "dark": "Dark",
    "system": "Same as system"
  },
  "user": {
    "menu": "Account menu for {{name}}",
    "signOut": "Sign out",
    "signedOut": "Signed out",
    "changePassword": "Change password",
    "appearance": "Appearance",
    "myCommission": "My commission"
  },
  "home": {
    "greeting": {
      "morning": "Good morning, {{name}}",
      "afternoon": "Good afternoon, {{name}}",
      "evening": "Good evening, {{name}}"
    },
    "shortcuts": "Start here",
    "myWork": {
      "title": "My work",
      "hint": "Your tasks and visits for today, and what is waiting on you."
    },
    "newTask": {
      "title": "New task",
      "hint": "Give work to a person or a team, with a due date."
    },
    "serviceOverview": {
      "title": "Service overview",
      "hint": "Today's visits, open jobs and what needs a decision."
    },
    "myVisits": {
      "title": "My visits",
      "hint": "The visits you are scheduled for: start, report and finish them."
    },
    "findCustomer": {
      "title": "Find a customer",
      "hint": "Search by name, code or mobile, and open the record."
    },
    "newCustomer": {
      "title": "Add a customer",
      "hint": "Create a customer record with contacts and groups."
    },
    "groups": {
      "title": "Customer groups",
      "hint": "See how customers are grouped, and who is in each group."
    },
    "noAccess": "There's nothing you can open yet.",
    "noAccessHint": "Ask your administrator to give your account access to the screens you need.",
    "modulesOff": "The areas you work in are turned off for your company.",
    "modulesOffHint": "Your access is kept. Ask your administrator to have them turned back on.",
    "paletteTip": "Press {{shortcut}} anywhere to jump to a screen or run a command.",
    "suppliers": {
      "title": "Find a supplier",
      "hint": "Contact and bank details of the companies you buy from."
    },
    "newExpense": {
      "title": "Record an expense",
      "hint": "Rent, utilities, fuel: with tax, paid from cash or bank."
    },
    "newJournal": {
      "title": "Post a journal entry",
      "hint": "A manual entry with balanced debits and credits."
    },
    "trialBalance": {
      "title": "Trial balance",
      "hint": "Opening, movement and closing balance of every account."
    },
    "newInvoice": {
      "title": "Create an invoice",
      "hint": "Invoice a customer: products by name, SKU or barcode, with VAT."
    },
    "recordReceipt": {
      "title": "Record a receipt",
      "hint": "Money received from a customer, applied to their open invoices."
    },
    "newPurchase": {
      "title": "Record a purchase",
      "hint": "A supplier's bill for goods received: posting it brings them into stock."
    },
    "openTill": {
      "title": "Open the till",
      "hint": "Sell at the counter: scan, take payment, print the receipt."
    }
  },
  "dashboard": {
    "label": "Key figures",
    "asOf": "Figures as of",
    "today": "Today",
    "onDate": "On {{date}}",
    "since": "from {{date}}",
    "sectionFailed": "Couldn't show these figures.",
    "sales": {
      "title": "Net sales (before VAT)",
      "invoices_one": "{{n}} invoice",
      "invoices_other": "{{n}} invoices",
      "monthToDate": "Month to date",
      "yearToDate": "Fiscal year to date",
      "last12Months": "Last 12 months",
      "trendLabel": "Net sales by month, {{from}} to {{to}}; latest month {{latest}}",
      "subtitle": "Net of credit notes, before VAT"
    },
    "receivables": {
      "title": "Receivables",
      "total": "Owed by customers",
      "overdue": "Overdue",
      "mostOverdue": "Most overdue",
      "aging": "Receivables by age"
    },
    "payables": {
      "title": "Payables",
      "total": "Owed to suppliers",
      "overdue": "Overdue",
      "dueNext7Days": "Due in the next 7 days",
      "overdueShort": "Overdue",
      "weekShort": "Due this week",
      "laterShort": "Later"
    },
    "cash": {
      "title": "Cash and bank",
      "total": "Total cash and bank",
      "none": "No cash or bank accounts yet."
    },
    "stock": {
      "title": "Stock",
      "value": "Stock value at cost",
      "lowStock": "Items at or below reorder level",
      "shortfall": "Short of the reorder level"
    },
    "projects": {
      "title": "Projects",
      "active": "Open projects",
      "attention": "Needs attention",
      "readyToBill": "Ready to bill",
      "outstanding": "Outstanding from customers",
      "all": "All projects",
      "retentionHeld": "Retention held",
      "guaranteesExpiring": "Guarantees expiring in 30 days"
    },
    "books": {
      "title": "Books health",
      "critical": "Critical",
      "warning": "Warning",
      "info": "Note",
      "checked": "Checks of {{from}} – {{to}} ran on {{date}}",
      "notChecked": "Checks haven't run yet this month"
    },
    "cheques": {
      "title": "Cheques",
      "toDeposit": "To deposit",
      "due": "Due for payment",
      "received": "Received",
      "issued": "Issued",
      "atBank": "At the bank",
      "late_one": "{{n}} late to clear",
      "late_other": "{{n}} late to clear",
      "postDated": "Post-dated",
      "bounced": "Bounced, 30 days",
      "week": "Due this week"
    },
    "pos": {
      "title": "Point of sale",
      "openShifts": "Shifts open now",
      "net": "Net till sales (before VAT)",
      "sales_one": "{{day}} · {{n}} sale",
      "sales_other": "{{day}} · {{n}} sales",
      "returns": "Till returns"
    },
    "top": {
      "customers": "Top customers",
      "products": "Top products",
      "period": "Period",
      "month": "Month",
      "year": "Year",
      "noSales": "No posted sales in this period yet.",
      "otherLines": "Other lines",
      "margin": "{{margin}}% margin"
    },
    "latest": {
      "title": "Latest invoices",
      "all": "All invoices",
      "none": "No invoices yet. Create your first invoice.",
      "draft": "Draft"
    }
  },
  "restricted": {
    "label": "Change your password"
  }
}
